import type { Key, MouseEventHandler } from 'react';
import { forwardRef } from 'react';
import type { LayoutProps, TextProps } from '@chakra-ui/react';
import { Td, Text, useBreakpointValue } from '@chakra-ui/react';
import format from 'date-fns/format';

type Props = {
  id: Key;
  date: string;
  textProps?: TextProps;
  dateFormat?: string;
  dateLocale?: Locale;
  onClick?: MouseEventHandler;
} & LayoutProps;

export const DateCell = forwardRef<HTMLTableCellElement, Props>(
  ({ onClick, dateLocale, dateFormat, date, id, textProps, ...props }, ref) => {
    const defaultDateFormat = useBreakpointValue({ md: 'P', lg: 'PPP' }, { ssr: false });

    return (
      <Td
        key={id}
        ref={ref}
        onClick={onClick}
        display={{ base: 'none', '2xl': 'table-cell' }}
        {...props}>
        <Text variant='tableCell' {...textProps}>
          {format(new Date(date), dateFormat ?? defaultDateFormat ?? 'PPP', {
            locale: dateLocale,
          })}
        </Text>
      </Td>
    );
  },
);
